import { Button, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';
import { PaymentSummaryRateType, paymentSummaryRateTypes } from '@parkchirp/reporting';
import { useCallback } from 'react';

type Props = {
	selectedRateTypes: PaymentSummaryRateType[];
	onChange: (value: PaymentSummaryRateType[]) => void;
};

export const RateTypesFilter = ({ selectedRateTypes, onChange }: Props) => {
	const allSelected = selectedRateTypes.length === paymentSummaryRateTypes.length;

	const selectAll = useCallback(() => {
		onChange([...paymentSummaryRateTypes]);
	}, [onChange]);

	const clear = useCallback(() => {
		onChange([]);
	}, [onChange]);

	const handleRateTypeChange = useCallback(
		(rateType: PaymentSummaryRateType, checked: boolean) => {
			if (checked) {
				onChange([...selectedRateTypes, rateType]);
				return;
			}

			onChange(selectedRateTypes.filter((selected) => selected !== rateType));
		},
		[onChange, selectedRateTypes],
	);

	return (
		<Stack spacing={2}>
			<Stack direction='row' justifyContent='space-between' alignItems='center'>
				<Typography variant='subtitle1' fontWeight={600}>
					Rate types
				</Typography>

				<Stack direction='row' spacing={1}>
					<Button size='small' variant='text' onClick={selectAll} disabled={allSelected}>
						Select all
					</Button>
					<Button size='small' variant='text' onClick={clear} disabled={selectedRateTypes.length === 0}>
						Clear
					</Button>
				</Stack>
			</Stack>

			<Stack direction='row' flexWrap='wrap' columnGap={3} rowGap={1}>
				{paymentSummaryRateTypes.map((rateType) => (
					<FormControlLabel
						key={rateType}
						control={
							<Checkbox
								checked={selectedRateTypes.includes(rateType)}
								onChange={(event) => handleRateTypeChange(rateType, event.target.checked)}
							/>
						}
						label={rateType}
					/>
				))}
			</Stack>
		</Stack>
	);
};
